export default {
  NODE_ENV: "production",
  REACT_APP_APP_DOMAIN: "*",
  REACT_APP_DEFAULT_LOCALE: "fr",
  REACT_APP_API_URL: "https://api.yeswever.com",
  REACT_APP_ADMIN_URL: "https://admin.yeswever.com",
  REACT_APP_USER_URL: "https://yeswever.com",
  REACT_APP_DIAG_URL: "https://diag.yeswever.com",
  REACT_APP_CAPTCHA_TOKEN: "66cebef2-cf37-44cd-8829-5422e36c1844"
};